export const downscaling = [{
  name: '4K',
  value: 4096
}, {
  name: '2K',
  value: 2048
}, {
  name: '1K',
  value: 1024
}, {
  name: '512',
  value: 512
}, {
  name: '256',
  value: 256
}];